module.exports = __webpack_public_path__ + "media/images/mypage/btn05_ov-d0b928a9970ae91468c40216df6d422e.gif";